export const state = {
    empresasResponse: [],
    totemResponse: [],
    dashboard: null,
    estatisticas: null,
    tat: null,
    workline: null,
    benchmark: null,
    mesSelected: null,
}

export const mutations = {
    SET_EMPRESA_RESPONSE(state, payload) {
        state.empresasResponse = payload
    },
    SET_TOTEM_RESPONSE(state, payload) {
        state.totemResponse = payload
    },
    SET_DASHBOARD(state, payload) {
        state.dashboard = payload
    },
    SET_ESTATISTICAS(state, payload) {
        state.estatisticas = payload
    },
    SET_TAT(state, payload) {
        state.tat = payload
    },
    SET_WORKLINE(state, payload) {
        state.workline = payload
    },
    SET_BENCHMARK(state, payload) {
        state.benchmark = payload
    },
    SET_MES_SELECTED(state, payload) {
        if (payload !== state.mesSelected) {
            state.benchmark = null
        }
        state.mesSelected = payload
    },
}

export const actions = {
    changeEmpresaResponse({ commit }, payload) {
        commit('SET_EMPRESA_RESPONSE', payload)
    },
    changeTotemResponse({ commit }, payload) {
        commit('SET_TOTEM_RESPONSE', payload)
    },
    changeDashboard({ commit }, payload) {
        commit('SET_DASHBOARD', payload)
    },
    changeEstatisticas({ commit }, payload) {
        commit('SET_ESTATISTICAS', payload)
    },
    changeTat({ commit }, payload) {
        commit('SET_TAT', payload)
    },
    changeWorkline({ commit }, payload) {
        commit('SET_WORKLINE', payload)
    },
    changeBenchmark({ commit }, payload) {
        commit('SET_BENCHMARK', payload)
    },
    changeMesSelected({ commit }, payload) {
        commit('SET_MES_SELECTED', payload)
    },
    cleanPainelControleGlobal({commit}) {
        commit('SET_EMPRESA_RESPONSE', [])
        commit('SET_TOTEM_RESPONSE', [])
        commit('SET_DASHBOARD', null)
        commit('SET_ESTATISTICAS', null)
        commit('SET_TAT', null)
        commit('SET_WORKLINE', null)
        commit('SET_BENCHMARK', null)
        commit('SET_MES_SELECTED', null)
    }
}